import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCog, faSignOutAlt, faUserCircle, faCaretDown,
} from '@fortawesome/free-solid-svg-icons';
import { Link, RedirectException, withRouter } from 'found';
import PropTypes from 'prop-types';
import React from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import {
  Collapse, Container, Dropdown, DropdownItem, DropdownMenu, DropdownToggle,
  Nav, Navbar, NavbarToggler,
} from 'reactstrap';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';

import { AvatarItem } from 'src/enosikit/components/Avatar';
import AnonymousNavigation from 'src/components/Navigation/AnonymousNavigation';
import NavigationLogo from 'src/components/Navigation/NavigationLogo';
import { APIConfig } from 'src/config';

const RightNav = styled(Nav).attrs({
  className: 'ms-auto',
})``;

const LeftNav = styled(Nav).attrs({
  className: 'me-auto',
})``;

class AdminNavigation extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      adminDropdownOpen: false,
      navbarOpen: false,
      profileDropdownOpen: false,
    };
  }

  toggleNavbar = () => {
    this.setState((prevState) => ({ navbarOpen: !prevState.navbarOpen }));
  };

  toggleAdmin = () => {
    this.setState((prevState) => ({ adminDropdownOpen: !prevState.adminDropdownOpen }));
  };

  toggleProfile = () => {
    this.setState((prevState) => ({ profileDropdownOpen: !prevState.profileDropdownOpen }));
  };

  render() {
    const { viewer } = this.props;
    const { adminDropdownOpen, navbarOpen, profileDropdownOpen } = this.state;

    if (!viewer) {
      const { match } = this.props;
      const { location } = match;
      const { pathname, search } = location;

      throw new RedirectException(`/login?redirect=${pathname}${search}`);
    }

    const { viewerUser } = viewer;
    const { givenName, familyName, email } = viewerUser;
    let name = [givenName, familyName].filter(Boolean).join(' ');
    if (name === '') {
      name = email;
    }

    if (!viewer) {
      return <AnonymousNavigation />;
    }

    const cobrand = APIConfig().cobrand();
    const primaryBrand = APIConfig().primaryBrand();

    return (
      <Navbar light expand="lg">
        <Container className="d-flex flex-wrap justify-content-between px-0 px-sm-3">
          <Link to="/" className="navbar-brand">
            <NavigationLogo cobrand={cobrand} primaryBrand={primaryBrand} />
          </Link>
          <NavbarToggler onClick={this.toggleNavbar} />
          <Collapse isOpen={navbarOpen} navbar>
            <LeftNav navbar>
              <Dropdown nav inNavbar isOpen={adminDropdownOpen} toggle={this.toggleAdmin}>
                <DropdownToggle nav>
                  <FormattedMessage id="navigation.admin_navigation.togle_admin" defaultMessage="Admin" />
                </DropdownToggle>
                <DropdownMenu>
                  <DropdownItem header>
                    <FormattedMessage id="navigation.admin_navigation.dropdown_item.common.header.label" defaultMessage="Common" />
                  </DropdownItem>
                  <Link to="/admin/users" className="dropdown-item" role="menuitem" onClick={this.toggleAdmin}>
                    <FormattedMessage id="navigation.admin_navigation.users.link.label" defaultMessage="Users" />
                  </Link>
                  <DropdownItem header>
                    <FormattedMessage id="navigation.admin_navigation.dropdown_item.customer.header.label" defaultMessage="Customer" />
                  </DropdownItem>
                  <Link to="/admin/communities" className="dropdown-item" role="menuitem" onClick={this.toggleAdmin}>
                    <FormattedMessage id="navigation.admin_navigation.communities.link.label" defaultMessage="Communities" />
                  </Link>
                  <Link to="/admin/property-users" className="dropdown-item" role="menuitem" onClick={this.toggleAdmin}>
                    <FormattedMessage id="navigation.admin_navigation.property_users.link.label" defaultMessage="PropertyUsers" />
                  </Link>
                  <Link to="/admin/properties" className="dropdown-item" role="menuitem" onClick={this.toggleAdmin}>
                    <FormattedMessage id="navigation.admin_navigation.properties.link.label" defaultMessage="Properties" />
                  </Link>
                  <Link to="/admin/primary-billing-points" className="dropdown-item" role="menuitem" onClick={this.toggleAdmin}>
                    <FormattedMessage id="navigation.admin_navigation.primary_billing_points.link.label" defaultMessage="Primary Billing Points" />
                  </Link>
                  <Link to="/admin/meters" className="dropdown-item" role="menuitem" onClick={this.toggleAdmin}>
                    <FormattedMessage id="navigation.admin_navigation.meters.link.label" defaultMessage=" Meters" />
                  </Link>
                  <Link to="/admin/standing-charges" className="dropdown-item" role="menuitem" onClick={this.toggleAdmin}>
                    <FormattedMessage id="navigation.admin_navigation.standing_charges.link.label" defaultMessage="Standing Charges" />
                  </Link>
                  <Link to="/admin/tariffs" className="dropdown-item" role="menuitem" onClick={this.toggleAdmin}>
                    <FormattedMessage id="navigation.admin_navigation.tariffs.link.label" defaultMessage="Tariffs" />
                  </Link>
                  <Link to="/admin/volume-charges" className="dropdown-item" role="menuitem" onClick={this.toggleAdmin}>
                    <FormattedMessage id="navigation.admin_navigation.volume_charges.link.label" defaultMessage="Volume Charges" />
                  </Link>
                  <DropdownItem divider />
                  <DropdownItem header>
                    <FormattedMessage id="navigation.admin_navigation.dropdown_item.historian.header.label" defaultMessage="Historian" />
                  </DropdownItem>
                  <Link to="/admin/historian/slices" className="dropdown-item" role="menuitem" onClick={this.toggleAdmin}>
                    <FormattedMessage id="navigation.admin_navigation.historian_slices.link.label" defaultMessage="Slices" />
                  </Link>
                  <DropdownItem divider />
                  <DropdownItem header>
                    <FormattedMessage id="navigation.admin_navigation.dropdown_item.trades.header.label" defaultMessage="Trades" />
                  </DropdownItem>
                  <Link to="/admin/trades" className="dropdown-item" role="menuitem" onClick={this.toggleAdmin}>
                    <FormattedMessage id="navigation.admin_navigation.trades.link.label" defaultMessage="Trades" />
                  </Link>
                  <DropdownItem divider />
                  <DropdownItem header>
                    <FormattedMessage id="navigation.admin_navigation.dropdown_item.trades_rules.header.label" defaultMessage="Trade Rules" />
                  </DropdownItem>
                  <Link to="/admin/trade-rules" className="dropdown-item" role="menuitem" onClick={this.toggleAdmin}>
                    <FormattedMessage id="navigation.admin_navigation.trade_rules.link.label" defaultMessage="Trade Rules" />
                  </Link>
                </DropdownMenu>
              </Dropdown>
            </LeftNav>
            <RightNav navbar>
              <Dropdown nav inNavbar isOpen={profileDropdownOpen} toggle={this.toggleProfile}>
                <DropdownToggle nav>
                  <AvatarItem
                    primaryText={name}
                    secondaryText={email}
                    avatarImage={<FontAwesomeIcon icon={faUserCircle} size="3x" />}
                    className="d-inline-flex"
                  />
                  <FontAwesomeIcon icon={faCaretDown} size="1x" className="ms-2" />
                </DropdownToggle>
                <DropdownMenu end>
                  <Link to="/profile/settings" activeClassName="active" className="dropdown-item" role="menuitem">
                    <FontAwesomeIcon icon={faCog} className="me-2" />
                    <FormattedMessage id="navigation.admin_navigation.current_user_settings.link.label" defaultMessage="Profile settings" />
                  </Link>
                  <DropdownItem divider />
                  <Link to="/logout" activeClassName="active" className="dropdown-item" role="menuitem">
                    <FontAwesomeIcon icon={faSignOutAlt} className="me-2" />
                    <FormattedMessage id="navigation.admin_navigation.log_out.link.label" defaultMessage="Log out" />
                  </Link>
                </DropdownMenu>
              </Dropdown>
            </RightNav>
          </Collapse>
        </Container>
      </Navbar>
    );
  }
}

AdminNavigation.propTypes = {
  match: PropTypes.shape({
    location: PropTypes.shape({
      pathname: PropTypes.string,
      search: PropTypes.string,
    }),
  }).isRequired,
  viewer: PropTypes.object, // eslint-disable-line react/forbid-prop-types
};

AdminNavigation.defaultProps = {
  viewer: null,
};

export default withRouter(createFragmentContainer(AdminNavigation, {
  viewer: graphql`
    fragment AdminNavigation_viewer on Viewer {
      id
      viewerUser {
        email
        givenName
        familyName
      }
    }
  `,
}));
